import { ComponentSettings, ISitePage } from '@src/types';
import { getComponentSettings } from '@src/sevices/component-settings-service/component-settings-service';
import { businessSettingsService } from '@src/sevices/business-settings-api/business-settings-api';
import { MODULE_ID } from '@src/config';
import { appDefIds } from '@wix/business-manager-api';
import { sitePagesService } from '@src/sevices/site-pages/site-pages-service';

export const getAppData = async (msid: string): Promise<AppInitialData> => {
  businessSettingsService.configBusinessSettings({
    moduleId: MODULE_ID,
    appDefIds: [appDefIds.consentPolicyBanner],
  });
  const [sitePages, { language }] = await Promise.all([
    sitePagesService.getSitePages(),
    businessSettingsService.getBusinessSettings(msid),
  ]);
  return {
    sitePages,
    componentSettings: await getComponentSettings(language),
    siteLanguage: language,
  };
};

export type AppInitialData = {
  componentSettings: ComponentSettings;
  siteLanguage: string;
  sitePages: ISitePage[];
};

export type GetAppDataService = {
  getAppData(msid: string): Promise<AppInitialData>;
};

export const getAppDataService: GetAppDataService = {
  getAppData,
};
